import { mapGetters } from "vuex";
import currency from "./currency";

export default {
  mixins: [currency],
  computed: {
    ...mapGetters("contractStore", [
      "contract",
      "totalBuyingPrice",
      "totalSellingPrice",
      "totalSellingPricePerExpedition",
      "previsional_expeditions",
      "real_expeditions"
    ])
  },
  methods: {
    showScoreCostSupplier(scoreCost) {
      this.$store.commit("contractStore/showScoreCostSupplier", {
        value: true,
        editedItem: scoreCost
      });
    },
    showScoreCostBankInvoiceDialog(scoreCost) {
      if (scoreCost.bank_invoice_link) {
        this.showBankInvoiceDialog(scoreCost.bank_invoice_link.bank_invoice);
        return;
      }

      /* Prefill default value for score cost bank invoice */
      scoreCost.bank_invoice = {
        score_cost_id: scoreCost.id,
        score_cost_name: scoreCost.name,
        amount: this.getCost(scoreCost),
        designation: `${this.contract.name} - ${scoreCost.name}`,
        currency_id: scoreCost.currency_id,
        subsidiary_company_id: this.contract.buying_company_id,
        company_id: scoreCost.supplier_id,
        operation_type: "debit"
      };
      scoreCost.bank_invoice.supplier_type_id = scoreCost.supplier_type_id;
      this.showBankInvoiceDialog(scoreCost.bank_invoice);
    },
    showBankInvoiceDialog(bankInvoice) {
      this.$store.commit("contractStore/showBankInvoiceDialog", {
        value: true,
        editedItem: bankInvoice
      });
    },
    getCost(scoreCost) {
      if (this.invoiceIsPresent(scoreCost))
        return this.invoicePrice(scoreCost);
      else return this.computeCost(scoreCost);
    },
    computeCost(scoreCost) {
      switch (scoreCost.calculation) {
        case "fixed_price":
          return this.getFixedPriceCost(scoreCost);
        case "freight_quantity_times_unit_price":
          return this.getFreightQuantityUnitPriceCost(scoreCost);
        case "quantity_times_unit_price":
          return this.getQuantityUnitPriceCost(scoreCost);
        case "net_weight_times_unit_price":
          return this.getNetWeightUnitPriceCost(scoreCost);
        case "percentage_times_customer_selling_price":
          return this.getPercentageCustomerCost(scoreCost);
        default:
          return 0;
      }
    },
    getComputedCostWithCurrentCurrency(scoreCost) {
      const cost = this.computeCost(scoreCost);
      const code = this.getCurrencyCode(scoreCost);
      return this.inCurrency(code, cost);
    },
    getCostWithCurrentCurrency(scoreCost) {
      const cost = this.getCost(scoreCost);
      const code = this.getCurrencyCode(scoreCost);
      return this.inCurrency(code, cost);
    },
    getCostWithScoreCurrency(scoreCost) {
      return this.inScoreCurrency(this.getScoreCost(scoreCost));
    },
    getScoreCost(scoreCost) {
      return this.getCost(scoreCost) * scoreCost.change_rate;
    },
    getLineCostWithScoreCurrency(scoreCostLine) {
      var cost = 0;
      for (var i = 0; i < scoreCostLine.length; i++) {
        cost += this.getCost(scoreCostLine[i]) * scoreCostLine[i].change_rate;
      }
      return this.inScoreCurrency(cost);
    },
    getCurrencyCode(scoreCost) {
      if (scoreCost.calculation === "percentage_times_customer_selling_price"){
        return this.contract.customer_currency.code;}
      return scoreCost.currency.code;
    },
    getFixedPriceCost(scoreCost) {
      return scoreCost.fixed_price;
    },
    getFreightQuantityUnitPriceCost(scoreCost) {
      return scoreCost.unit_price * this.shipmentQuantity(scoreCost);
    },
    getQuantityUnitPriceCost(scoreCost) {
      return scoreCost.unit_price * scoreCost.quantity;
    },
    getNetWeightUnitPriceCost(scoreCost) {
      return scoreCost.price_per_mt * this.totalNetWeight(scoreCost);
    },
    getPercentageCustomerCost(scoreCost) {
      return (
        (this.totalSellingPricePerExpedition(scoreCost.expedition) *
          scoreCost.percentage) /
        100
      );
    },
    shipmentQuantity(scoreCost) {
      if (this.previsional) {
        return this.previsional_expeditions
          .filter(e => e.shipment_id === scoreCost.shipment_id)
          .map(e => e.quantity)
          .reduce((v, a) => a + v, 0);
      } else {
        return this.real_expeditions.find(e => e.id === scoreCost.expedition_id)
          .shipping_units.length;
      }
    },
    ExpeditionTotalLoadedNetWeight(expedition) {
      let total = 0;
      if (!expedition.shipping_units) return 0;
      expedition.shipping_units.forEach(shipping_unit => {
        shipping_unit.shipping_unit_products.forEach(sup => {
          total += sup.loaded_net_weight_mt;
        });
      });
      return total;
    },
    totalNetWeight(scoreCost) {
      if (this.previsional) {
        if (scoreCost.shipment_id) {
          return this.previsional_expeditions
            .filter(e => e.id != "")
            .filter(e => e.shipment_id == scoreCost.shipment_id)
            .map(e => e.net_weight * e.quantity)
            .reduce((v, a) => a + v, 0);
        } else
          return this.contract.product_trades
            .filter(e => e.id != "")
            .map(e => e.net_weight)
            .reduce((v, a) => a + v, 0);
      } else {
        let exp = this.real_expeditions.find(
          e => e.id === scoreCost.expedition_id
        );
        return this.ExpeditionTotalLoadedNetWeight(exp);
      }
    },
    creditNotesTotal(scoreCost) {
      if (!scoreCost.bank_invoice_links)
        return 0
      return scoreCost.bank_invoice_links.filter(bil => bil.bank_invoice.is_credit_note).map(e => e.amount).reduce((a, b) => a + b, 0)
    },
    creditNotesTotalInCurrency(scoreCost) {
      return this.inCurrency(this.getCurrencyCode(scoreCost), this.creditNotesTotal(scoreCost))
    },
    invoiceDebitTotal(scoreCost) {
      if (!scoreCost.bank_invoice_links)
        return 0
      return scoreCost.bank_invoice_links.filter(bil => !bil.bank_invoice.is_credit_note).map(e => e.amount).reduce((a, b) => a + b, 0)
    },
    invoiceDebitTotalInCurrency(scoreCost) {
      return this.inCurrency(this.getCurrencyCode(scoreCost), this.invoiceDebitTotal(scoreCost))
    },
    invoicePrice(scoreCost) {
      return this.invoiceDebitTotal(scoreCost) - this.creditNotesTotal(scoreCost)
    },
    showInvoicePrice(scoreCost) {
      if (!this.invoiceIsPresent(scoreCost)) return false;
      return this.invoicePrice(scoreCost) != this.computeCost(scoreCost);
    },
    invoiceIsPresent(scoreCost) {
      if (!scoreCost.bank_invoice_links)
        return false

      return scoreCost.bank_invoice_links.filter(e => !e.is_credit_note).length > 0;
    },
    getCustomerCurrencySymbol() {
      /* TODO Find a better way to get symbol from code */
      return this.inCustomerCurrency(0).replace("0.00", "");
    },
    inSupplierCurrency(val) {
      return this.inCurrency(this.contract.supplier_currency.code, val);
    },
    inCustomerCurrency(val) {
      return this.inCurrency(this.contract.customer_currency.code, val);
    },
    inScoreCurrency(val) {
      return this.inCurrency(this.contract.score_currency.code, val);
    }
  }
};
